import React from "react";
import "./home3Styles.css";

const Home3 = () => {
  return (
    <div className="home3">
      <div className="container">
        <div className="content">
          <h2>
            <span className="grayText">Ame</span> os animais
          </h2>
          <p>
            Mesmo quando estamos nos sentindo sozinhos e sem nenhum amigo,
            nossos animais sempre estarão conosco. Nós precisamos mais deles do
            que ele de nós, e para que um possa cuidar do outro, é preciso que
            você adote e cuide bem de seu animal. Caso possua dúvidas, basta
            entrar em contato com nossa equipe.
          </p>
          <div>
            <button className="grayButton">Contatar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home3;
